export default {"src":"/_next/static/media/luggage-free.14bb4e54.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};